export default __webpack_public_path__ + "static/media/G0860.Breech_09-AllFours-Shoulder_Press.1695378780000.02828786.jpg";